import React from 'react';
import { useNavigate } from 'react-router-dom';
import './About.css';

function About() {
  const navigate = useNavigate();

  const handleJoinUsClick = () => {
    navigate('/contact'); 
  };

  return (
    <div className="about-us">
      <section className="about-us-content">
        <div className="about-section">
          <h2>O nas</h2>
          <p>
            Jesteśmy stowarzyszeniem, które zrzesza ludzi, lubiących spacery i piesze wycieczki. 
            Promujemy aktywne spędzanie wolnego czasu na świeżym powietrzu i poznawanie okoliczności przyrody województwa świętokrzyskiego i nie tylko.
          </p>
        </div>

        <div className="about-section">
          <h2> Góry Świętokrzyskie</h2>
          <p>
            Góry Świętokrzyskie to jeden z najbardziej malowniczych regionów Polski. Wierzymy, że każdy spacer po ich szlakach
            to nie tylko okazja do aktywności fizycznej, ale również odkrywanie historii, kultury i przyrody.
          </p>
        </div>

        <div className="about-section">
          <h2>Dołącz do Nas</h2>
          <p>
            Chcesz wziąć udział w naszych wydarzeniach? Dołącz do naszej społeczności i wspólnie eksplorujmy region, promujmy zdrowie
            i inspirujmy innych!
          </p>
          <div className="centered-button">
            <button className="join-us-button" onClick={handleJoinUsClick}>
              Kontakt
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;